import { OffboardReason } from "@/model/Prescription"

export const offboardReasonLabels: Record<OffboardReason, string> = {
  "device-connectivity-issue": "Device connectivity issue",
  "patient-completed-protocol": "Completed protocol",
  "patient-end-program-early": "End program early",
  "patient-non-compliant": "Non-compliant",
  "patient-transferred": "Transferred",
  "patient-declined": "Declined",
  other: "Other",
}
